export { default as PageBySlug } from "./PageBySlug";
